import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const generateQuestionAudio = async ({ assessmentName, questionId, questionText }) => {
    return apiWrapper({
      fetch,
      url: 'assessment/builder/generateQuestionTextToSpeech',
      options: {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ assessmentName, questionId, questionText })
      }
    });
  }

  return {
    generateQuestionAudio
  }
}
